import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'app-modal-language',
    templateUrl: './modal-language.template.html',
    encapsulation: ViewEncapsulation.None
  })

  export class ModalLanguageComponet implements OnInit {
    constructor(private bsModalRef: BsModalRef) {
}
    ngOnInit(): void {
      
    }
    private onCancel(): void {
      this.bsModalRef.hide();
    }
  }
